import React from "react";

interface UserDetailWishProps {}
const UserDetailWish: React.FC<UserDetailWishProps> = (props) => {
  return <div></div>;
};

export default UserDetailWish;
